<div [class]="hostClasses.join(' ')">
  <mat-icon class="material-symbols-rounded munily-alert__icon" aria-hidden="true">{{ iconLigature }}</mat-icon>

  <div class="munily-alert__labels">
    <p class="munily-alert__emphasis">{{ emphasisText }}</p>
    <p *ngIf="showDescription" class="munily-alert__description">{{ description }}</p>
  </div>
</div>

